import marketingApi from '@api/marketing'
import { PAY_ALIPAY } from '@components/Cashier/constant'
import {
  MARKETING_CENTER_PATH,
  PRODUCT_PRO,
  PRODUCT_STANDARD_PRO,
  SHOP_PRODUCTS_PATH
} from '@constant'
import { isHonorable, isStandard } from '@merchant-backend/util'
import { hashHistory } from 'react-router'
import { getProTitle } from './pro'

const checkCanContinue = product_id => {
  // 尊享版，对原有支付旗舰版的行为统一拦截
  if (
    isHonorable() &&
    (product_id == PRODUCT_PRO || product_id == PRODUCT_STANDARD_PRO)
  ) {
    hashHistory.push(SHOP_PRODUCTS_PATH)
    return false
  }

  return true
}

const handleProductId = product_id => {
  // 当前是标准版，升级旗舰版，product_id 为 198
  if (isStandard() && product_id == PRODUCT_PRO) {
    product_id = PRODUCT_STANDARD_PRO
  }

  return product_id
}

/**
 * 跳转支付页面统一方法,
 * @param {string} 支付标题
 * @param {*} 支付费用
 * @param {number} 产品id
 */
export const goPayment = async ({
  title = `购买${getProTitle()}`,
  fee,
  product_id = PRODUCT_PRO,
  apiName = '/p/wedding/index.php/admin/APIMerchantPro/pay',
  return_url = MARKETING_CENTER_PATH,
  payType = PAY_ALIPAY,
  payParams,
  deductible_money
} = {}) => {
  const canContinue = checkCanContinue(product_id)
  if (!canContinue) {
    return
  }

  // 未传入费用则默认获取旗舰版的价格
  if (!fee && fee !== 0) {
    const { success, data } = await marketingApi.fee()

    if (!success) {
      return
    }

    if (!data.fee) {
      return
    }

    fee = data.fee
  }

  const params = {
    price: fee.toFixed(2),
    payType,
    title,
    product_id: handleProductId(product_id),
    apiName,
    return_url
  }

  if (payParams) {
    params.payParams = JSON.stringify(payParams)
  }

  if (deductible_money) {
    params.deductible_money = deductible_money
  }

  let suffix = Object.keys(params).reduce((url, key) => {
    url += `${key}=${params[key]}&`
    return url
  }, '')

  if (suffix.endsWith('&')) {
    suffix = suffix.substr(0, suffix.length - 1)
  }

  const url = `/localMerchant/cashier?`
  hashHistory.push(url + suffix)
}

export const goShopProductPage = () => {
  hashHistory.push(SHOP_PRODUCTS_PATH)
}

export const isPaymentPage = () => {
  return window.location.hash.split('?')[0].indexOf('cashier') > -1
}
